export default __webpack_public_path__ + "static/media/lapices.8262ff58.png";